import angular from 'angular';
import 'angular-bootstrap';
import '../../locale';
import './pollsServices';
import '../../common/commonDirectives'

function changeOrderResponse(data, key1, key2) {
    'use strict';
    if (!Array.isArray(data) || data.length <= Math.max(key1, key2)) {
        return data;
    }

    const temp = data[key1];
    data[key1] = data[key2];
    data[key2] = temp;

    if ('order' in data[key1] && 'order' in data[key2]) {
        const tempOrder = data[key1].order;
        data[key1].order = data[key2].order;
        data[key2].order = tempOrder;
    }

    return data;
}

const pollsControllers = angular.module('applicationModule.pollsControllers', [
    'applicationModule.pollsServices',
    'ui.bootstrap'
]);

// Form List Controller
pollsControllers.controller('PollsController', ['$scope', '$rootScope', '$stateParams', 'NgTableParams', 'Polls', 'growl', 'AppsoupAPI', 'Permissions', '$state', '$modal', function ($scope, $rootScope, $stateParams, NgTableParams, Polls, growl, AppsoupAPI, Permissions, $state, $modal) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('polls');
    $scope.app_id = $stateParams.application_id;
    $scope.search = {};

    $scope.tableParams = new NgTableParams(AppsoupAPI.getIdTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return Polls.getList($scope.app_id, params._params)
                .then(function (response) {
                    params.total(response.polls.total);
                    params.count(response.polls.per_page);
                    params.page(response.polls.current_page);
                    $scope.package_id = response.package_id;
                    return response.polls.data;
                }).finally(function () {
                    $scope.isLoading = false;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.searchPolls = function (search) {
        const find = angular.copy(search);
        angular.extend($scope.tableParams._params, find);
    };

    $scope.clearSearch = function () {
        $scope.search = {};
        if (angular.isDefined($scope.tableParams._params.name)) {
            $scope.tableParams._params.name = undefined;
        }
    };

    $scope.newPoll = function () {
        const modalInstance = $modal.open({
            templateUrl: 'views/application/polls/poll.tpl.html',
            controller: 'PollModalController',
            resolve: {
                poll: function () {
                    return {
                        app_id: $scope.app_id
                    };
                }
            }
        });
        modalInstance.result.then(function (form) {
            $scope.tableParams.data.push(form);
            growl.success('MODULES.POLLS.SUCCESS.CREATED');
        }).catch(() => {});
    };

    $scope.editPoll = function (data, index) {
        const modalInstance = $modal.open({
            templateUrl: 'views/application/polls/poll.tpl.html',
            controller: 'PollModalController',
            resolve: {
                poll: function () {
                    return data;
                }
            }
        });
        modalInstance.result.then(function (form) {
            $scope.tableParams.data[index] = form;
            growl.success('MODULES.POLLS.SUCCESS.EDITED');
        }).catch(() => {});
    };

    $scope.copyPolls = function (id) {
        Polls.copy(id).then(function (response) {
            const data = response.data;
            if (data.success) {
                growl.success('MODULES.POLLS.SUCCESS.COPIED');
                $state.go($state.current, {searchPolls: $stateParams.searchPolls}, {reload: true});
            } else {
                const message = data.error === 'ERROR.POLL_NOT_EXISTS' ? 'MODULES.POLLS.ERROR.POLL_NOT_EXISTS' : 'MODULES.POLLS.ERROR.COPIED';
                growl.error(message);
            }
        });
    };

    $scope.removePoll = function (id, index) {
        Polls.remove(id, $scope.app_id)
            .then(function (response) {
                const data = response.data;
                if (data.success) {
                    growl.success('MODULES.POLLS.SUCCESS.DELETED');
                    $scope.tableParams.data.splice(index, 1);
                } else {
                    growl.error('MODULES.POLLS.ERROR.DELETED');
                }
            });
    };

    function downloadCSV(data) {
        const blob = new Blob([data], {type: 'text/csv;charset=utf-8;'});
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.click();
        window.URL.revokeObjectURL(url);
    }

    $scope.generateCSV = function (pollId) {
        Polls.generateCSV($scope.app_id, pollId)
            .then(function (data) {
                if (angular.isDefined(data.error)) {
                    growl.error(data.error);
                } else if (data) {
                    downloadCSV(data);
                } else {
                    growl.error(data.error);
                }
            });
    };
}]);

// Form Modal Controller
pollsControllers.controller('PollModalController', ['$scope', '$state', '$stateParams', '$modalInstance', 'growl', 'Polls', 'poll', function ($scope, $state, $stateParams, $modalInstance, growl, Polls, poll) {
    'use strict';
    const appId = $stateParams.application_id;
    $scope.poll = {};
    $scope.poll.app_id = appId;
    $scope.editMode = false;

    if (poll.name) {
        $scope.editMode = true;
        $scope.poll = angular.copy(poll);
    } else {
        $scope.poll.quiz = true;
    }

    $scope.ok = function () {
        $scope.$broadcast('show-errors-check-validity');
        $scope.isLoading = true;

        Polls.save($scope.poll, $scope.editMode)
            .then(function (response) {
                const data = response.data;
                if (data.success) {
                    $modalInstance.close(data.poll);
                } else {
                    if (typeof data.error === 'object') {
                        $scope.formErrors = data.error;
                    } else {
                        growl.error('MODULES.FORMS.ERROR.CREATED');
                    }
                }
            })
            .finally(function () {
                $scope.isLoading = false;
            });
    };

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.remove = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.inputErrors = {
        'name': [{type: '$invalid', msg: 'ERROR.REQUIRE.NAME'}],
        'mail': [{type: '$invalid', msg: 'ERROR.REQUIRE.MAIL'}],
        'mail_title': [{type: '$invalid', msg: 'ERROR.REQUIRE.MAIL_TITLE'}],
        'date_from': [{type: '$invalid', msg: 'ERROR.REQUIRE.TIME_FROM'}],
        'date_to': [{type: '$invalid', msg: 'ERROR.REQUIRE.TIME_TO'}]
    };
}]);

// Poll Elements List Controller
pollsControllers.controller('PollElementsController', ['$scope', '$rootScope', '$stateParams', 'NgTableParams', 'PollElements', 'growl', 'AppsoupAPI', 'Permissions', '$state', '$modal', function ($scope, $rootScope, $stateParams, NgTableParams, PollElements, growl, AppsoupAPI, Permissions, $state, $modal) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('polls');
    $scope.app_id = $stateParams.application_id;
    $scope.poll_id = $stateParams.pollId;

    $scope.tableParams = new NgTableParams(AppsoupAPI.getTitleTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return PollElements.getList($scope.app_id, $scope.poll_id, params._params)
                .then(function (data) {
                    const response = data.data;
                    params.total(response.elements.total);
                    params.count(response.elements.per_page);
                    params.page(response.elements.current_page);
                    $scope.parents = response.parents;
                    $scope.options = response.options;
                    return response.elements.data;
                }).catch(function () {
                    $state.go('appsoup.application.polls');
                    growl.error('ERROR.EMPTY_DATA');
                }).finally(function () {
                    $scope.isLoading = false;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.newElement = function () {
        const modalInstance = $modal.open({
            templateUrl: 'views/application/polls/elements/element.tpl.html',
            controller: 'PollElementModalController',
            size: 'lg',
            resolve: {
                element: function () {
                    return {
                        app_id: $scope.application_id,
                        poll_id: $scope.poll_id
                    };
                }
            }
        });
        modalInstance.result.then(function (element) {
            $scope.tableParams.data.push(element);
            growl.success('MODULES.POLLS.ELEMENTS.SUCCESS.CREATED');
        }).catch(() => {});
    };

    $scope.editElement = function (data, index) {
        const modalInstance = $modal.open({
            templateUrl: 'views/application/polls/elements/element.tpl.html',
            controller: 'PollElementModalController',
            size: 'lg',
            resolve: {
                element: function () {
                    return data;
                }
            }
        });
        modalInstance.result.then(function (element) {
            $scope.tableParams.data[index] = element;
            growl.success('MODULES.POLLS.ELEMENTS.SUCCESS.EDITED');
        }).catch(() => {});
    };

    $scope.remove = function ($event) {
        $event.stopImmediatePropagation();
    };

    $scope.removeElement = function (id, index) {
        PollElements.remove(id, $scope.app_id)
            .then(function (data) {
                if (data.success) {
                    growl.success('MODULES.POLLS.ELEMENTS.SUCCESS.DELETED');
                    $scope.tableParams.data.splice(index, 1);
                } else {
                    growl.error('MODULES.POLLS.ELEMENTS.ERROR.DELETED');
                }
            });
    };

    $scope.changeOrder = function ($event, key1, key2) {
        let data = $scope.tableParams.data;

        $event.stopImmediatePropagation();
        PollElements.changeOrder({
            order_ids: [$scope.tableParams.data[key1].order, $scope.tableParams.data[key2].order],
            app_id: $scope.app_id
        })
            .then(function (response) {
                if (response.data.success) {
                    data = changeOrderResponse(data, key1, key2);
                    $scope.tableParams.data = data;
                }
            });

    };

}]);

// Poll Element Modal Controller
pollsControllers.controller('PollElementModalController', ['$scope', '$filter', '$state', '$stateParams', '$modalInstance', 'growl', 'PollElements', 'element', '$modal', function ($scope, $filter, $state, $stateParams, $modalInstance, growl, PollElements, element, $modal) {
    'use strict';
    const appId = $stateParams.application_id;
    $scope.element = {};
    $scope.element.app_id = appId;
    $scope.element.poll_id = element.poll_id;
    $scope.editMode = false;
    $scope.elementId = undefined;
    $scope.element.content = '';
    $scope.lang = $filter('translate')('LANG');
    $scope.tinymceOptions = {
        height: 300,
        plugins: 'link image code',
        toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | code'
    };
    if (element.title) {
        $scope.editMode = true;
        $scope.element = angular.copy(element);
        $scope.elementId = $scope.element.id;
        if ($scope.element.url) {
            $scope.fileUploaded = true;
        }
    }

    if (angular.isDefined($scope.lang) && $scope.lang !== 'en') {
        $scope.tinymceOptions['language'] = $scope.lang;
        $scope.tinymceOptions['language_url'] = '/assets/tinymce/' + $scope.lang + '.js';
    }

    PollElements.create(appId, $scope.editMode, $scope.elementId, $scope.element.poll_id)
        .then(function (response) {
            if (response.data.success) {
                $scope.types = response.data.types;
                $scope.parents = response.data.parents;
                $scope.options = response.data.options;
            }
        });

    $scope.$watch('element.parent', function (newVal, oldVal) {
        if (newVal !== oldVal) {
            $scope.element.for_option = undefined;
        }
    });

    $scope.replaceChars = function (text) {
        const dict = {'ą': 'a', 'ę': 'e', 'ć': 'c', 'ł': 'l', 'ń': 'n', 'ó': 'o', 'ś': 's', 'ż': 'z', 'ź': 'z'};
        let str = angular.copy(text);
        str = str.replace(/\s+/g, '_').toLowerCase();
        str = str.replace(/<[^>]*>/g, '');
        str = str.replace(/[^\w ]/g, function (char) {
            return dict[char] || char;
        });
        str = str.replace(/[^0-9a-z-]+/g, '_');
        str = str.replace(/[-]+/g, '_');

        return str;
    };

    $scope.generateLink = function () {
        if ($scope.element.title) {
            $scope.element.key = $scope.replaceChars($scope.element.title);
        }
    };

    $scope.$watch('element.key', function (oldValue, newValue) {
        if ($scope.element.key) {
            if (oldValue !== newValue) {
                $scope.element.key = $scope.replaceChars($scope.element.key);
            }
        }
    });


    $scope.ok = function () {
        $scope.$broadcast('show-errors-check-validity');
        $scope.isLoading = true;

        PollElements.save($scope.element, $scope.editMode)
            .then(function (response) {
                const data = response.data;
                if (data.success) {
                    $modalInstance.close(data.element);
                } else {
                    if (typeof data.error === 'object') {
                        $scope.formErrors = data.error;
                    } else {
                        growl.error('MODULES.POLLS.ELEMENTS.ERROR.CREATED');
                    }
                }
            })
            .finally(function () {
                $scope.isLoading = false;
            });
    };

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.remove = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.inputErrors = {
        'title': [{type: '$invalid', msg: 'ERROR.REQUIRE.TITLE'}],
        'key': [{type: '$invalid', msg: 'ERROR.REQUIRE.KEY'}],
        'date_from': [{type: '$invalid', msg: 'ERROR.REQUIRE.TIME_FROM'}],
        'date_to': [{type: '$invalid', msg: 'ERROR.REQUIRE.TIME_TO'}],
        'type': [{type: '$invalid', msg: 'ERROR.REQUIRE.TYPE'}]
    };
}]);

// Poll Element Options List Controller
pollsControllers.controller('PollElementOptionsController', ['$scope', '$rootScope', '$stateParams', 'NgTableParams', 'PollElements', 'growl', 'AppsoupAPI', 'Permissions', '$state', '$modal', function ($scope, $rootScope, $stateParams, NgTableParams, PollElements, growl, AppsoupAPI, Permissions, $state, $modal) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('polls');
    $scope.app_id = $stateParams.application_id;
    $scope.poll_id = $stateParams.pollId;
    $scope.element_id = $stateParams.elementId;

    PollElements.get($scope.element_id, $scope.app_id)
        .then(function (response) {
            if (angular.isNullOrUndefined(response.data.element)) {
                growl.error('ERROR.EMPTY_DATA');
                $state.go('appsoup.application.pollElements', {pollId: $stateParams.pollId});
            }
            $scope.element = response.data.element;
            $scope.options = response.data.element.options;
        }).finally(function () {
        $scope.isLoading = false;
    });

    $scope.newOption = function () {
        const modalInstance = $modal.open({
            templateUrl: 'views/application/polls/elements/options/option.tpl.html',
            controller: 'PollElementOptionModalController',
            resolve: {
                option: function () {
                    return {
                        app_id: $scope.application_id,
                        poll_id: $scope.poll_id,
                        element_id: $scope.element_id
                    };
                },
                element: function () {
                    return $scope.element;
                }
            }
        });
        modalInstance.result.then(function (option) {
            $scope.options.push(option);
            growl.success('MODULES.POLLS.ELEMENTS.OPTIONS.SUCCESS.CREATED');
        }).catch(() => {});
    };

    $scope.editOption = function (data, index) {
        const modalInstance = $modal.open({
            templateUrl: 'views/application/polls/elements/options/option.tpl.html',
            controller: 'PollElementOptionModalController',
            resolve: {
                option: function () {
                    return data;
                },
                element: function () {
                    return $scope.element;
                }
            }
        });
        modalInstance.result.then(function (option) {
            $scope.options[index] = option;
            growl.success('MODULES.POLLS.ELEMENTS.OPTIONS.SUCCESS.CREATED');
        }).catch(() => {});
    };

    $scope.remove = function ($event) {
        $event.stopImmediatePropagation();
    };

    $scope.removeOption = function (id, index) {
        PollElements.removeOption(id, $scope.element_id)
            .then(function (response) {
                const data = response.data;
                if (data.success) {
                    growl.success('MODULES.POLLS.ELEMENTS.OPTIONS.SUCCESS.DELETED');
                    $scope.options.splice(index, 1);
                } else {
                    growl.error('MODULES.POLLS.ELEMENTS.OPTIONS.ERROR.DELETED');
                }
            });
    };

    $scope.changeOrder = function ($event, key1, key2) {
        let data = $scope.options;
        $event.stopImmediatePropagation();
        PollElements.changeOptionOrder({
            order_ids: [$scope.options[key1].order, $scope.options[key2].order],
            app_id: $scope.app_id,
            element_id: $scope.element_id
        })
            .then(function (response) {
                if (response.data.success) {
                    data = changeOrderResponse(data, key1, key2);
                }
            });
        $scope.options = data;
    };

}]);

// Poll Element Modal Controller
pollsControllers.controller('PollElementOptionModalController', ['$scope', '$filter', '$state', '$stateParams', '$modalInstance', 'growl', 'PollElements', 'option', 'element', '$modal', function ($scope, $filter, $state, $stateParams, $modalInstance, growl, PollElements, option, element, $modal) {
    'use strict';
    const appId = $stateParams.application_id;
    $scope.option = {};
    $scope.element = element;
    $scope.option.app_id = appId;
    $scope.option.poll_id = option.poll_id;
    $scope.option.element_id = option.element_id;
    $scope.editMode = false;
    $scope.optionId = undefined;
    $scope.elementNameExists = false;
    $scope.elementType = element.type;
    $scope.canCheckCorrectAnswer = false;

    if (option.key) {
        $scope.editMode = true;
        $scope.option = angular.copy(option);
        $scope.optionId = $scope.option.id;
    }

    if ($scope.element.quiz) {
        PollElements.checkCorrectAnswer($scope.option.element_id, $scope.optionId).then(
            function (response) {
                $scope.canCheckCorrectAnswer = response.data.canCheck;
            }
        );
    }

    $scope.lang = $filter('translate')('LANG');
    $scope.tinymceOptions = {
        height: 300,
        plugins: 'link image code',
        toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | code'
    };

    if (angular.isDefined($scope.lang) && $scope.lang !== 'en') {
        $scope.tinymceOptions['language'] = $scope.lang;
        $scope.tinymceOptions['language_url'] = '/assets/tinymce/' + $scope.lang + '.js';
    }


    $scope.ok = function () {
        $scope.$broadcast('show-errors-check-validity');
        $scope.isLoading = true;

        PollElements.saveOption($scope.option, $scope.editMode)
            .then(function (response) {
                const data = response.data;
                if (data.success) {
                    $modalInstance.close(data.option);
                } else {
                    if (typeof data.error === 'object') {
                        $scope.formErrors = data.error;
                    } else {
                        if (data.error == 'ELEMENT_KEY_EXISTS') {
                            $scope.elementNameExists = true;
                            growl.error('MODULES.POLLS.ELEMENTS.ERROR.KEY_EXISTS');
                        } else {
                            growl.error('MODULES.POLLS.ELEMENTS.OPTIONS.ERROR.CREATED');
                        }
                    }
                }
            })
            .finally(function () {
                $scope.isLoading = false;
            });
    };

    $scope.replaceChars = function (text) {
        const dict = {'ą': 'a', 'ę': 'e', 'ć': 'c', 'ł': 'l', 'ń': 'n', 'ó': 'o', 'ś': 's', 'ż': 'z', 'ź': 'z'};
        let str = angular.copy(text);
        str = str.replace(/\s+/g, '_').toLowerCase();
        str = str.replace(/[^\w ]/g, function (char) {
            return dict[char] || char;
        });
        str = str.replace(/[^0-9a-z-]+/g, '_');
        str = str.replace(/[-]+/g, '_');

        return str;
    };

    $scope.generateKey = function () {
        if ($scope.option.value) {
            $scope.option.key = $scope.replaceChars($scope.option.value);
        }
        $scope.changeElementNameExists();
    };

    $scope.changeElementNameExists = function () {
        if ($scope.elementNameExists === true) {
            $scope.elementNameExists = false;
        }
    };

    $scope.$watch('option.key', function (oldValue, newValue) {
        if ($scope.option.key) {
            if (oldValue != newValue) {
                $scope.option.key = $scope.replaceChars($scope.option.key);
            }
        }
    });

    $scope.changeTags = function () {
        if (angular.isDefined($scope.option.tags)) {
            const tempTags = [];
            angular.forEach($scope.option.tags, function (value) {
                value = $filter('lowercase')(value);
                value = $filter('removeSpecial')(value);
                value = $filter('changeSpecial')(value);
                if (angular.isDefined(value) && tempTags.indexOf(value) === -1) {
                    tempTags.push(value);
                }
            });
            $scope.option.tags = tempTags;
        }
    };

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.remove = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.inputErrors = {
        'key': [{type: '$invalid', msg: 'ERROR.REQUIRE.KEY'}],
        'value': [{type: '$invalid', msg: 'ERROR.REQUIRE.VALUE'}]
    };

}]);

// Poll Results List Controller
pollsControllers.controller('PollResultsController', ['$scope', '$rootScope', '$stateParams', 'NgTableParams', 'PollResults', 'growl', 'AppsoupAPI', 'Permissions', '$modal', function ($scope, $rootScope, $stateParams, NgTableParams, PollResults, growl, AppsoupAPI, Permissions, $modal) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('polls');
    $scope.app_id = $stateParams.application_id;
    $scope.poll_id = $stateParams.pollId;

    $scope.tableParams = new NgTableParams(AppsoupAPI.getIdTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return PollResults.getList($scope.app_id, $scope.poll_id, params._params)
                .then(function (response) {
                    params.total(response.results.total);
                    params.count(response.results.per_page);
                    params.page(response.results.current_page);
                    return response.results.data;
                }).finally(function () {
                    $scope.isLoading = false;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.newResult = function () {
        const modalInstance = $modal.open({
            templateUrl: 'views/application/polls/results/result.tpl.html',
            controller: 'PollResultModalController',
            size: 'lg',
            resolve: {
                result: function () {
                    return {
                        app_id: $scope.application_id,
                        poll_id: $scope.poll_id
                    };
                }
            }
        });
        modalInstance.result.then(function (result) {
            $scope.tableParams.data.unshift(result);
            growl.success('MODULES.POLLS.RESULTS.SUCCESS.CREATED');
        }).catch(() => {});
    };

    $scope.editResult = function (data, index) {
        const modalInstance = $modal.open({
            templateUrl: 'views/application/polls/results/result.tpl.html',
            controller: 'PollResultModalController',
            size: 'lg',
            resolve: {
                result: function () {
                    return data;
                }
            }
        });
        modalInstance.result.then(function (result) {
            $scope.tableParams.data[index] = result;
            growl.success('MODULES.POLLS.RESULTS.SUCCESS.EDITED');
        }).catch(() => {});
    };

    $scope.remove = function ($event) {
        $event.stopImmediatePropagation();
    };

    $scope.removeResult = function (id, index) {
        PollResults.remove(id, $scope.app_id)
            .then(function (data) {
                if (data.success) {
                    growl.success('MODULES.POLLS.RESULTS.SUCCESS.DELETED');
                    $scope.tableParams.data.splice(index, 1);
                } else {
                    growl.error('MODULES.POLLS.RESULTS.ERROR.DELETED');
                }
            });
    };

}]);

// Poll Result Modal Controller
pollsControllers.controller('PollResultModalController', ['$scope', '$filter', '$state', '$stateParams', '$modalInstance', 'growl', 'PollResults', 'result', '$modal', function ($scope, $filter, $state, $stateParams, $modalInstance, growl, PollResults, result, $modal) {
    'use strict';
    const appId = $stateParams.application_id;
    $scope.result = {
        data: {}
    };
    $scope.result.app_id = appId;
    $scope.result.poll_id = result.poll_id;
    $scope.editMode = false;
    $scope.resultId = undefined;
    $scope.result.content = '';
    $scope.lang = $filter('translate')('LANG');
    $scope.tinymceOptions = {
        height: 300,
        plugins: 'link image code',
        toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | code'
    };
    if (result.title) {
        $scope.editMode = true;
        $scope.result = angular.copy(result);
        $scope.resultId = $scope.result.id;
    }

    if (angular.isDefined($scope.lang) && $scope.lang !== 'en') {
        $scope.tinymceOptions['language'] = $scope.lang;
        $scope.tinymceOptions['language_url'] = '/assets/tinymce/' + $scope.lang + '.js';
    }

    $scope.ok = function () {
        $scope.$broadcast('show-errors-check-validity');
        $scope.isLoading = true;

        PollResults.save($scope.result, $scope.editMode)
            .then(function (data) {
                if (data.success) {
                    $modalInstance.close(data.result);
                } else {
                    if (typeof data.error === 'object') {
                        $scope.formErrors = data.error;
                    } else {
                        growl.error('MODULES.POLLS.RESULTS.ERROR.CREATED');
                    }
                }
            })
            .finally(function () {
                $scope.isLoading = false;
            });
    };

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.remove = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.changeTags = function () {
        if (angular.isDefined($scope.result.tags)) {
            const tempTags = [];
            angular.forEach($scope.result.tags, function (value) {
                value = $filter('lowercase')(value);
                value = $filter('removeSpecial')(value);
                value = $filter('changeSpecial')(value);
                if (angular.isDefined(value) && tempTags.indexOf(value) === -1) {
                    tempTags.push(value);
                }
            });
            $scope.result.tags = tempTags;
        }
    };

    $scope.inputErrors = {
        'title': [{type: '$invalid', msg: 'ERROR.REQUIRE.TITLE'}],
        'content': [{type: '$invalid', msg: 'ERROR.REQUIRE.CONTENT'}]
    };
}]);

export default pollsControllers;
